import type { ReactElement } from "react";
import { useCustom } from "@refinedev/core";
import { Phone } from "lucide-react";

import { Button } from "@/components/ui/button";

interface JoinSupportCallButtonProps {
  chatRoomId: number | null;
}

interface JoinableCall {
  roomId: string;
}

/**
 * Кнопка «Войти в звонок» в шапке переписки тикета поддержки. Поллит
 * GET /admin/calls/by-chat/:chatRoomId (раз в 5с) — если по этому support-чату
 * есть не завершённый звонок, показывает активную кнопку, открывающую
 * LiveKit-комнату админки (роут /livestreams/stage/:roomId). Если звонка нет —
 * ничего не рендерит.
 */
export function JoinSupportCallButton({ chatRoomId }: JoinSupportCallButtonProps): ReactElement | null {
  const { result } = useCustom<JoinableCall>({
    url: `/admin/calls/by-chat/${chatRoomId}`,
    method: "get",
    queryOptions: {
      enabled: Number.isFinite(chatRoomId),
      refetchInterval: 5000,
    },
  });

  const roomId = result?.data?.roomId;
  if (!roomId) {
    return null;
  }

  const handleJoin = () => {
    window.open(
      `/livestreams/stage/${roomId}?label=${encodeURIComponent("Поддержка")}`,
      "_blank",
    );
  };

  return (
    <Button size="sm" onClick={handleJoin}>
      <Phone className="mr-2 h-4 w-4" />
      Войти в звонок
    </Button>
  );
}
